<div class="card text-decoration-none" [ngClass]="getStyle(point)" [class.highlighted]="highlighted" 
  (mouseenter)="hover()" (mouseleave)="unhover()">  
  <div class="card-body d-flex align-items-center text m-5px text-truncate text-uppercase" >
    <div class="flex-fill">
      <div class="mb-1">{{widget.name}}</div>
      <h2 *ngIf="point == null">...</h2>
      <h2 *ngIf="point != null && point.value != null && !isNaN(point.value)">{{point.value | number}} <small>{{widget.units}}</small></h2>
      <h2 *ngIf="point != null && point.value != null && isNaN(point.value)">{{point.value}}</h2>
    </div>
    <div class="opacity-5">
      <i class="fa fa-4x" [ngClass]="getIcon(point)"></i>
    </div>
  </div>
</div>